import styled from 'styled-components';

const Modal = styled.div`
	background-color: rgba(0, 0, 0, 0.7);
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	z-index: 10000;
	display: ${props => props.open ? 'flex' : 'none'};
	align-items: center;
	justify-content: center;
`;

const ModalWrapper = styled.div`
	background-color: #fff;
	box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
	position: relative;
	width: 100%;
	max-width: 1200px;
	margin: 2rem;
`;

const ModalHeader = styled.div`
	padding: 1.5rem;
	border-bottom: 1px solid #ccc;
	font-size: 1.25rem;
	font-weight: bold;
	display: flex;
	align-items: center;
`;

const ModalFooter = styled.div`
	border-top: 1px solid #ccc;
	padding: 1.5rem;
	display: flex;
	justify-content: flex-end;
`;

const ModalContent = styled.div`
	max-height: 70vh;
	overflow-y: auto;
	padding: 1.5rem;
`;

const NoSelectedItems = styled.div`
	padding: 1rem;
	text-align: center;
	color: #777;
	font-size: 1.125rem;
`;

const SelectableItems = styled.div`
	display: flex;
	flex-flow: row wrap;
	justify-items: center;
`;

const SelectableItem = styled.button`
	background-color: transparent;
	padding: 1rem;
	margin: 1rem;
	flex: 0 0 calc(20% - 2rem);
	border: 2px solid ${props => props.selected ? '#4A90E2' : 'transparent'};
	box-shadow: 0px 0px 6px 0px ${props => props.selected ? '#4A90E2' : 'transparent'};
	transition: all 0.2s ease-out;
	overflow: hidden;
	display: block;
	width: 100%;
	cursor: pointer;

	&:hover {
		background-color: #eee;
	}
}
`;

const SelectionCount = styled.span`
	float: right;
	font-size: 1rem;
	font-weight: normal;
	color: #777;
	margin-left: 0.5rem;
`;

export {
	Modal,
	ModalWrapper,
	ModalContent,
	ModalHeader,
	ModalFooter,
	SelectableItems,
	SelectableItem,
	NoSelectedItems,
	SelectionCount
}
